import { Component, OnInit, Input } from '@angular/core';
import { ValidationResultDTO } from '../../../api/plyca-dtos-v2';


@Component({
  selector: 'validationResultMessages',
  templateUrl: 'validationResultMessages.template.html'
})
export class ValidationResultMessagesComponent implements OnInit {

  @Input()
  validationresult: ValidationResultDTO;

  ngOnInit(): void {
  }

}